export default __webpack_public_path__ + "static/eKYC-portal-for-hotel-check-ins-d90ab877ca1c853d1918c5038b3ae0df.png";